module.exports = __webpack_public_path__ + "static/f20img2-30961808df1c8a1b47112f8252e2dbde.jpg";